import { MarpolPollutionCategoryEnum } from 'src/enums/stowage/marpolPollutionCategoryEnum';
import { MarpolRegulationEnum } from 'src/types/BusinessModel/Stowage/Product/MarpolRegulationEnum';
import { ProductCategoryBM } from 'src/types/BusinessModel/Stowage/Product/ProductCategoryBM';
import { ProductCategory } from 'src/types/ViewModel/Stowage/Product/ProductCategory';

export const createProductCategory = (productCategoryBM: ProductCategoryBM): ProductCategory => {
    return {
        id: productCategoryBM.id,
        name: productCategoryBM.name,
        isAnnexIIChapter17: productCategoryBM.regulations.marpolRegulation === MarpolRegulationEnum.AnnexIIChapter17,
        isInhibited: productCategoryBM.isInhibited,
        shallNotBeExposedToExcessiveHeat: productCategoryBM.shallNotBeExposedToExcessiveHeat,
        marpolPollutionCategory: productCategoryBM.regulations.marpolPollutionCategory as MarpolPollutionCategoryEnum,
        shipType: productCategoryBM.regulations?.ibcRegulation?.shipType,
        tankType: productCategoryBM.regulations?.ibcRegulation?.tankType,
        ibcSpecificRequirements:
            productCategoryBM.regulations?.ibcRegulation?.specificAndOperationalRequirements?.map((r) => r.paragraphNumber) ?? [],
    };
};

export const createProductCategoryList = (list: ProductCategoryBM[]) => list.map((pc) => createProductCategory(pc));
